import React from "react";

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Heading,
  VStack
} from "@chakra-ui/react";

import { isLocal } from "@/util/environments";

export interface GenericErrorMessageProps {
  error: Error;
  componentStack: string | null;
}

export const GenericErrorMessage: React.FC<GenericErrorMessageProps> = ({
  error,
  componentStack
}) => (
  <VStack spacing={4} alignItems="stretch">
    <Alert status="error">
      <AlertIcon />
      <Box>
        <AlertTitle>Something went wrong</AlertTitle>
        <AlertDescription>
          Please try refreshing the page or contact support if the problem
          persists.
        </AlertDescription>
      </Box>
    </Alert>
    {isLocal() && error.stack && (
      <Box data-testid="stack">
        <Heading size="sm">Stack trace</Heading>
        <pre>{error.stack}</pre>
      </Box>
    )}
    {isLocal() && componentStack && (
      <Box data-testid="component-stack">
        <Heading size="sm">Component stack</Heading>
        <pre>{componentStack}</pre>
      </Box>
    )}
  </VStack>
);
